import * as React from "react";
import { Language, FieldValueLocaleTextarea } from "typings/index";
import { BaseFieldEditor } from "../helper";
import TextEditor from "./TextEditor";
import { 
    CommandBar, 
    ICommandBarItemProps, 
    Dialog, 
    DialogFooter,
    PrimaryButton,
    DefaultButton
} from "office-ui-fabric-react";
import styled from "styled-components";
import { Map } from "~/../typings";
import { GetLanguageMenu } from "./languageHelper";

export interface Props extends BaseFieldEditor
{
    value: FieldValueLocaleTextarea;
    placeholder?: string;
    languages: Language[];
}

const Editor = styled.div`
    span{
        cursor: pointer;
        width: 94%;
        height: 100%;
        display: block;
        background: white;
        padding: 3%;
        white-space: pre-wrap; 
   }
`;

const DialogContentStyle = styled.div`
    z-index: 100;
    position: relative;
    display: flex;
   .locale-textarea
   {

        float: left;
        width: 48%;
        &:first-child
        {
            padding: 0 4% 2% 0;
        }
        
       textarea
       {
            width: 98%;
            min-height: 150px;
            margin-bottom: 0 !important;
       }
   }
`;

function LocaleTextareaEditor(props: Props)
{
    const [language, setLanguage] = React.useState<Language>(props.languages[0]);
    const [edit, setEdit] = React.useState<boolean>(false);

    const [value, setValue] = React.useState<Map<string> | undefined>(props.value ? props.value.value : undefined);

    const toggleEditMode = () => setEdit(!edit);

    const onSave = () =>
    {
        const fieldValue: FieldValueLocaleTextarea = {...props.value, value };
        props.onValueChange(fieldValue);
        toggleEditMode();
    };

    const onCancel =  () =>
    {
        setValue(props.value ? props.value.value : undefined);
        toggleEditMode();
    };

    
    const onValueChange = (language: string, newValue: string) =>
    {
        const temp= {...value};
        temp[language] = newValue;
        setValue(temp);
    };

    const commandBarOptions: ICommandBarItemProps[] = GetLanguageMenu(props.languages, setLanguage, language);
    
    return (
        <Editor>
            <CommandBar
                style={{background: "transparent"}}
                items={commandBarOptions}
                farItems={[{name:"Edit", key:"edit", onClick: toggleEditMode}]}
            />
            <span onClick={toggleEditMode}>
                {value ? value[language.name] : undefined}
            </span>
            <Dialog hidden={!edit} onDismiss={toggleEditMode} minWidth={900} 
                dialogContentProps={{title: props.field.label._DEFAULT }}
                modalProps={{
                    topOffsetFixed: true
                }}
                >
                    <DialogContentStyle>
                        <TextEditor
                            languageDefaultIndex={props.languages.findIndex(x => x.name === language.name)}
                            languages={props.languages}
                            values={value}
                            onValueChange= {onValueChange}
                            focus={true}
                        />    
                        {props.languages.length > 1 ? <TextEditor
                            languageDefaultIndex={1}
                            languages={props.languages}
                            values={value}
                            onValueChange= {onValueChange}
                        /> : null}    
                    </DialogContentStyle>
                <DialogFooter>
                    <PrimaryButton onClick={onSave} text="Save" />
                    <DefaultButton onClick={onCancel} text="Cancel" />
                </DialogFooter>
            </Dialog>
        </Editor>
    );
}

export default LocaleTextareaEditor;


// WEBPACK FOOTER //
// ./src/components/product/FieldEditor/localeTextareaEditor/LocaleTextareaEditor.tsx